import axios from 'axios';
import { handleTokenInvalidation } from './tokenHandler';

const BASE_URL = 'https://server.battleverse.cn';

const request = axios.create({
  baseURL: BASE_URL,
  timeout: 10000,
  withCredentials: false,
  headers: {
    'Content-Type': 'application/json'
  }
});

// 请求拦截器
request.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 添加防止重复登出的标记
let isHandlingTokenInvalidation = false;
// 添加上次处理token失效的时间
let lastTokenInvalidationTime = 0;

// 响应拦截器
request.interceptors.response.use(
  (response) => {
    const { data } = response;
    // 如果响应中包含新的token，更新存储
    if (data.data && data.data.token) {
      localStorage.setItem('token', data.data.token);
    }

    // 处理token无效的情况 (code: -1)
    if (data.code === -2) {
      // 防止短时间内多次触发登出
      const now = Date.now();
      const MIN_INVALIDATION_INTERVAL = 3000; // 3秒内不重复处理

      if (!isHandlingTokenInvalidation && (now - lastTokenInvalidationTime > MIN_INVALIDATION_INTERVAL)) {
        isHandlingTokenInvalidation = true;
        lastTokenInvalidationTime = now;

        // 使用统一的token失效处理函数
        handleTokenInvalidation(data.msg || '登录已失效，请重新登录', response.config.headers.Authorization?.replace(/^Bearer /, ''));

        // 延迟重置处理状态
        setTimeout(() => {
          isHandlingTokenInvalidation = false;
        }, 2000);
      } else {
        console.log('已有token失效处理正在进行，忽略此次请求');
      }

      // 创建错误对象并返回
      const error = new Error(data.msg || 'Token无效，请重新登录');
      error.code = data.code;
      return Promise.reject(error);
    }

    if (data.code === 0) {
      return data;
    }
    // 处理其他错误
    const error = new Error(data.msg || '请求失败');
    error.code = data.code;
    return Promise.reject(error);
  },
  (error) => {
    // 防止短时间内多次触发登出
    const now = Date.now();
    const MIN_INVALIDATION_INTERVAL = 3000; // 3秒内不重复处理

    if (error.response?.status === 401 ||
        (error.response?.data?.code === 401) ||
        error.response?.data?.msg?.includes('未登录') ||
        error.response?.data?.msg?.includes('登录已过期')) {

      if (!isHandlingTokenInvalidation && (now - lastTokenInvalidationTime > MIN_INVALIDATION_INTERVAL)) {
        isHandlingTokenInvalidation = true;
        lastTokenInvalidationTime = now;

        // 使用统一的token失效处理函数
        handleTokenInvalidation('登录已过期，请重新登录', error.config?.headers?.Authorization?.replace(/^Bearer /, ''));

        // 延迟重置处理状态
        setTimeout(() => {
          isHandlingTokenInvalidation = false;
        }, 2000);
      } else {
        console.log('已有token失效处理正在进行，忽略此次请求');
      }
    }
    return Promise.reject(error);
  }
);

export default request;
